export default {
  email: null,
  name: null,
  token: null,
  userType: null,
  loading: false
}
